export const ONBOARDING_STORAGE_KEY = 'kapusons_ai_chatbot_onboarding_v1';
export const ONBOARDING_SESSION_KEY = 'kapusons_ai_chatbot_onboarding_session_v1';
export const ONBOARDING_VERSION = 1;

export const getBrowserStorage = (storageName, scope = globalThis) => {
  if (!['localStorage', 'sessionStorage'].includes(storageName)) return null;

  try {
    return scope?.[storageName] ?? null;
  } catch {
    return null;
  }
};

const getItem = (storage, key) => {
  try {
    return storage?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

const setItem = (storage, key, value) => {
  try {
    storage?.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const clearOnboardingPreference = (storage) => {
  try {
    storage?.removeItem(ONBOARDING_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
};

export const readOnboardingPreference = (storage, now = Date.now()) => {
  const raw = getItem(storage, ONBOARDING_STORAGE_KEY);

  if (!raw) return false;

  try {
    const marker = JSON.parse(raw);
    const valid =
      marker?.v === ONBOARDING_VERSION &&
      Number.isFinite(marker?.expiresAt) &&
      marker.expiresAt > now;

    if (!valid) clearOnboardingPreference(storage);

    return valid;
  } catch {
    clearOnboardingPreference(storage);
    return false;
  }
};

export const saveOnboardingPreference = (
  storage,
  maxAgeDays,
  now = Date.now()
) => {
  const days = Number(maxAgeDays);

  if (!Number.isFinite(days) || days <= 0) return false;

  return setItem(
    storage,
    ONBOARDING_STORAGE_KEY,
    JSON.stringify({
      v: ONBOARDING_VERSION,
      expiresAt: now + days * 24 * 60 * 60 * 1000,
    })
  );
};

export const readSessionOnboarding = (storage) =>
  getItem(storage, ONBOARDING_SESSION_KEY) === String(ONBOARDING_VERSION);

export const saveSessionOnboarding = (storage) =>
  setItem(storage, ONBOARDING_SESSION_KEY, String(ONBOARDING_VERSION));

export const clearSessionOnboarding = (storage) => {
  try {
    storage?.removeItem(ONBOARDING_SESSION_KEY);
    return true;
  } catch {
    return false;
  }
};
